import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    paidBreakMinutes?: ?number;
}

export class TimesheetEntryPaidBreakMinutes extends React.PureComponent<Props> {
    render() {
        const { paidBreakMinutes } = this.props;
        if (!paidBreakMinutes) return null;
        return paidBreakMinutes;
    }
}

const mapStateToProps = createStructuredSelector({
    paidBreakMinutes: makeSelectTimesheetEntryValue('paidBreakMinutes')
});

export default connect(mapStateToProps)(TimesheetEntryPaidBreakMinutes);
